export default __webpack_public_path__ + "static/media/swiftlynx.b800b391.png";